module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"weight":"Weight {percent}%","updatedSinceReview":"Updated since review","changesSinceReview":"Changes since review","comment":"Remark","customTargetWeight":"Weight"},"de":{"weight":"Gewichtung {percent}%","updatedSinceReview":"Seit der Bewertung aktualisiert","changesSinceReview":"Änderungen seit der Bewertung","comment":"Anmerkung","customTargetWeight":"Gewichtung"}}')
  delete Component.options._Ctor
}
